import { useState, useEffect, useCallback } from 'react';
import { VoiceAssistantToolsService } from '@/services/voice/VoiceAssistantToolsService';
import { VoiceAssistantTool, OpenAITool } from '@/types/voiceAssistantTools';
import { useBrandManager } from '@/hooks/useBrandManager';

export const useVoiceAssistantTools = () => {
  const { currentBrandId } = useBrandManager();
  const [tools, setTools] = useState<VoiceAssistantTool[]>([]);
  const [openAITools, setOpenAITools] = useState<OpenAITool[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchTools = useCallback(async () => {
    if (!currentBrandId) {
      setTools([]);
      setOpenAITools([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const fetchedTools = await VoiceAssistantToolsService.getActiveToolsForBrand(currentBrandId);
      setTools(fetchedTools);
      setOpenAITools(VoiceAssistantToolsService.convertToOpenAITools(fetchedTools));
    } catch (err) {
      console.error('Error fetching voice assistant tools:', err);
      setError(err instanceof Error ? err : new Error('Failed to fetch tools'));
      setTools([]);
      setOpenAITools([]);
    } finally {
      setIsLoading(false);
    }
  }, [currentBrandId]);

  useEffect(() => {
    fetchTools();
  }, [fetchTools]);

  return {
    tools,
    openAITools,
    isLoading,
    error,
    refetch: fetchTools
  };
};
